import { Box, Typography } from '@mui/material';

/**
 * AWS's white/reversed attribution lockup. The site runs on a dark surface,
 * where the standard dark lockup is near-invisible.
 */
const LOGO_DEFAULT = '/images/aws-marketplace-badge-white.png';

/**
 * MarketplaceHeader - Reusable header component for marketplace sections
 * Features AWS logo and title with green accent bars
 *
 * @param {Object} props - Component props
 * @param {string} [props.title] - Section title
 * @param {string} [props.logoSrc] - Logo image path, overriding the default
 * @param {string} [props.logoAlt] - Logo alt text
 * @param {Object} [props.sx] - Additional MUI sx styling
 * @returns {JSX.Element} Marketplace header component
 */
function MarketplaceHeader({
  title = 'RSMC Solutions & Services',
  logoSrc,
  logoAlt = 'Available in AWS Marketplace',
  sx = {},
}) {
  const resolvedLogo = logoSrc || LOGO_DEFAULT;

  return (
    <Box
      sx={{
        borderTop: '4px solid var(--color-primary)',
        borderBottom: '4px solid var(--color-primary)',
        backgroundColor:
          'color-mix(in srgb, var(--color-primary) 5%, transparent)',
        py: 3,
        mb: 6,
        ...sx,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        {/* Title */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
            mb: 2,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: 'var(--color-heading)',
              fontWeight: 600,
              fontSize: { xs: '2rem', md: '2.5rem' },
              fontFamily: '"Playfair Display", serif',
            }}
          >
            {title}
          </Typography>
        </Box>

        {/* Logo */}
        <Box>
          <img
            src={resolvedLogo}
            alt={logoAlt}
            loading="lazy"
            style={{
              height: '6rem',
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default MarketplaceHeader;
